/** @jsx dom */
import dom from 'magic-virtual-element';
import Slide from '@viskan/deku-slide';
import {Image} from '~/media';
import getIcon from '../../../utils/actions';

const parseNumber = (num, defaultValue) => parseInt(num, 10) || defaultValue;
const getImage = (stateString, props) => <Image class={props.styleClasses.Image} source={props[`image${stateString}`]} data-style-attr='Image'/>;
const getPresentation = (stateString, props) => {
	switch (props.sliderArrowsType) {
		case 'icon': {
			return getIcon({icon: props[`icon${stateString}`], iconColor: props[`icon${stateString}Color`], iconSize: props[`icon${stateString}Size`], label: stateString});
		}
		case 'image': {
			return getImage(stateString, props);
		}
		case 'text':
		default: {
			return stateString;
		}
	}
};

export const handleImageClick = props => () => {
	props.openPopup((
		<div class='CMS-ArticleMedia-popupImage'>
			<Image key={props.currentMedia.filename} source={props.currentMedia.filename} scale='large' alt={props.currentMedia.media_alt_desc || props.article.artname}/>
		</div>
	), {
		width: 'auto',
		height: '96vh',
		class: 'CMS-ArticleMedia-popup'
	});
};

export const updateSlider = (currentMedia, loop) => instance => {
	if (loop) {
		return;
	}

	instance.slideTo(currentMedia.index);
};

export const getSliderCommon = (props, getContent) => {
	const imageArray = v12.article.medias(props.article, {
		sku: {
			attr1_id: props.active.attr1_id,
			attr2_id: props.isSizeMatchRequired ? props.active.attr2_id : undefined
		},
		size: ''
	});
	const key = imageArray.map(image => image.filename).join(',');
	const hasMultipleImages = imageArray.length > 1;
	const iconNext = (props.iconNext || props.imageNext) && props.sliderArrowsType !== 'none' ? getPresentation('Next', props) : '';
	const iconPrev = (props.iconPrev || props.imagePrev) && props.sliderArrowsType !== 'none' ? getPresentation('Prev', props) : '';

	const options = {
		initialSlide: props.currentMedia.prevIndex || 0,
		roundLengths: true,
		simulateTouch: !props.cmsLoaded
	};

	const settings = {
		arrows: hasMultipleImages && props.sliderArrows,
		iconNext,
		iconPrev,
		duration: parseNumber(props.sliderDuration, 3000),
		loop: hasMultipleImages && props.sliderLoop,
		options,
		pagination: hasMultipleImages && props.sliderPagination,
		paginationType: props.paginationType,
		play: hasMultipleImages && props.sliderAutoplay,
		speed: parseNumber(props.sliderSpeed, 500),
		timing: props.timing
	};

	const onChange = (props, imageArray) => data => {
		const index = data.activeIndex;
		const img = imageArray.find((image, i) => i === index);

		props.setCurrentMedia({
			...img,
			filename: img.filename,
			index,
			path: img.path,
			prevIndex: props.currentMedia.index
		});
	};

	return (<Slide key={key} class='CMS-ArticleMedia-Slider' onInit={updateSlider(props.currentMedia, props.sliderLoop)} onChange={onChange(props, imageArray)} {...settings}>{getContent(imageArray, props)}</Slide>);
};
